import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Pages/Home";
import Footer from "./components/Footer";
import TheLogo from "./components/TheLogo";
import Navbar from "./components/Navbar";
import BigShift from "./components/BigShift/NHIPage";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

export default function App() {
  return (
    <BrowserRouter>
    <Navbar/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/TheLogo" element={<TheLogo />} />
        <Route path="/natural-human-intelligence" element={<BigShift />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}